(() => {
  const LANDING_SELECTOR = '[data-advent-calendar-landing]';
  let swymReady = window._swat || null;

  const getStrings = () => (window.gwaStrings && window.gwaStrings.advent_calendar) || {};

  const setWishlistButtonState = (button, state) => {
    const isLoading = state === 'loading';
    const isAdded = state === 'added' || (
      isLoading && button.getAttribute('aria-pressed') === 'true'
    );

    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);
    button.classList.toggle('swym-added', isAdded);
    button.setAttribute('aria-pressed', String(isAdded));
    button.setAttribute(
      'aria-label',
      isAdded
        ? (getStrings().wishlistRemove || 'Aus der Wunschliste entfernen')
        : (getStrings().wishlistAdd || 'Zur Wunschliste hinzufügen')
    );
  };

  const getWishlistProduct = (button) => ({
    empi: Number(button.getAttribute('data-product-id')),
    epi: Number(button.getAttribute('data-variant-id')),
    du: button.getAttribute('data-product-url'),
    et: 4
  });

  const isWishlistItem = (item, product) => (
    String(item && item.empi) === String(product.empi)
    && String(item && item.epi) === String(product.epi)
  );

  const setMatchingWishlistButtons = (button, state) => {
    const landing = button.closest(LANDING_SELECTOR) || document;
    const product = getWishlistProduct(button);

    landing.querySelectorAll('[data-advent-wishlist-button]').forEach((candidate) => {
      if (isWishlistItem(getWishlistProduct(candidate), product)) {
        setWishlistButtonState(candidate, state);
      }
    });
  };

  const fetchWishlistItems = (swat, callback) => {
    if (!swat || typeof swat.fetchWrtEventTypeET !== 'function') {
      callback(null);
      return;
    }

    try {
      swat.fetchWrtEventTypeET(
        (items) => callback(Array.isArray(items) ? items : []),
        swat.EventTypes && swat.EventTypes.addToWishList
          ? swat.EventTypes.addToWishList
          : 4
      );
    } catch (error) {
      callback(null);
    }
  };

  const refreshWishlistStates = (swat, scope = document) => {
    fetchWishlistItems(swat, (items) => {
      if (!items) return;

      scope.querySelectorAll('[data-advent-wishlist-button]').forEach((button) => {
        const isAdded = items.some((item) => isWishlistItem(item, getWishlistProduct(button)));
        setWishlistButtonState(button, isAdded ? 'added' : 'idle');
      });
    });
  };

  const toggleWishlist = (button, swat) => {
    const product = getWishlistProduct(button);

    fetchWishlistItems(swat, (items) => {
      const isAdded = items
        ? items.some((item) => isWishlistItem(item, product))
        : button.getAttribute('aria-pressed') === 'true';
      const method = isAdded ? 'removeFromWishList' : 'addToWishList';

      if (!swat || typeof swat[method] !== 'function') {
        setWishlistButtonState(button, isAdded ? 'added' : 'idle');
        return;
      }

      try {
        swat[method](
          product,
          () => setMatchingWishlistButtons(button, isAdded ? 'idle' : 'added'),
          () => setWishlistButtonState(button, isAdded ? 'added' : 'idle')
        );
      } catch (error) {
        setWishlistButtonState(button, isAdded ? 'added' : 'idle');
      }
    });
  };

  const handleWishlistClick = (event) => {
    const button = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    if (button.disabled) return;

    setWishlistButtonState(button, 'loading');

    const activeSwat = swymReady || window._swat;

    if (activeSwat) {
      toggleWishlist(button, activeSwat);
      return;
    }

    let cancelled = false;
    const timeout = window.setTimeout(() => {
      cancelled = true;
      setWishlistButtonState(button, 'idle');
    }, 8000);

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push((swat) => {
      swymReady = swat;
      if (cancelled) return;

      window.clearTimeout(timeout);
      toggleWishlist(button, swat);
    });
  };

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push((swat) => {
    swymReady = swat;
    refreshWishlistStates(swat);
  });

  const normalizeMoney = (value) => {
    const money = value == null ? '' : String(value);

    return money.replace(/&(?:amp;)?nbsp;|&#(?:160|xA0);/gi, '\u00A0');
  };

  const setText = (elements, value) => {
    elements.forEach((element) => {
      element.textContent = value || '';
    });
  };

  const syncWishlistProduct = (card, product, resetState = false) => {
    if (!product || !product.url) return;

    let productUrl = product.url;

    try {
      productUrl = new URL(product.url, window.location.origin).href;
    } catch (error) {
      // Relative Shopify URLs remain valid if URL normalization is unavailable.
    }

    card.querySelectorAll('[data-advent-wishlist-button]').forEach((button) => {
      button.setAttribute('data-product-id', product.productId || '');
      button.setAttribute('data-variant-id', product.variantId || '');
      button.setAttribute('data-product-url', productUrl);

      if (resetState) {
        button.setAttribute('aria-pressed', 'false');
        button.classList.remove('swym-added');
      }
    });

    card.querySelectorAll('[data-swym-product-id]').forEach((element) => {
      element.setAttribute('data-swym-product-id', product.productId || '');
    });
  };

  const setProductState = (card, key) => {
    const dataElement = card.querySelector('[data-advent-product-data]');

    if (!dataElement) return;

    let products;

    try {
      products = JSON.parse(dataElement.textContent);
    } catch (error) {
      return;
    }

    const product = products[key] || products.base;

    if (!product) return;

    const previousKey = card.dataset.adventActiveProduct;

    card.dataset.adventActiveProduct = key;

    setText(card.querySelectorAll('[data-advent-product-title]'), product.title);
    setText(card.querySelectorAll('[data-advent-product-price]'), normalizeMoney(product.price));

    card.querySelectorAll('[data-advent-product-badges]').forEach((container) => {
      const badges = Array.isArray(product.badges) ? product.badges : [];

      container.replaceChildren(...badges.map((badgeData) => {
        const badge = document.createElement('span');
        badge.className = `advent-calendar__badge badge ${badgeData.className || 'badge__custom'}`;
        badge.textContent = badgeData.text || '';
        return badge;
      }));
    });

    card.querySelectorAll('[data-advent-product-compare]').forEach((element) => {
      const comparePrice = normalizeMoney(product.comparePrice);
      element.textContent = comparePrice;
      element.hidden = !comparePrice;
    });

    card.querySelectorAll('[data-advent-product-sku-wrap]').forEach((element) => {
      element.hidden = !product.sku;
    });
    setText(card.querySelectorAll('[data-advent-product-sku]'), product.sku);

    card.querySelectorAll('[data-advent-media-title]').forEach((element) => {
      element.hidden = element.dataset.adventMediaTitle !== key;
    });

    const features = Array.isArray(product.features) ? product.features : [];

    card.querySelectorAll('[data-advent-feature]').forEach((element, index) => {
      const feature = features[index] || '';
      const featureText = element.querySelector('[data-advent-feature-text]');

      if (featureText) featureText.textContent = feature;
      element.hidden = !feature;
    });

    card.querySelectorAll('[data-advent-product-link]').forEach((link) => {
      if (product.url) {
        link.href = product.url;
        link.removeAttribute('aria-disabled');
      } else {
        link.removeAttribute('href');
        link.setAttribute('aria-disabled', 'true');
      }
    });

    card.querySelectorAll('[data-advent-product-image]').forEach((image) => {
      const emptyMedia = image.parentElement.querySelector('[data-advent-empty-media]');

      if (product.image) {
        image.src = product.image;
        image.alt = product.imageAlt || product.title || '';
        image.hidden = false;
        if (emptyMedia) emptyMedia.hidden = true;
      } else {
        image.removeAttribute('src');
        image.alt = '';
        image.hidden = true;
        if (emptyMedia) {
          emptyMedia.hidden = false;
          const label = emptyMedia.querySelector('[data-advent-empty-media-label]');
          if (label) label.textContent = product.title || getStrings().defaultTitle || 'Adventskalender';
        }
      }
    });

    card.querySelectorAll('[data-advent-product-select]').forEach((button) => {
      const isSelected = button.dataset.adventProductSelect === key;
      button.setAttribute('aria-pressed', String(isSelected));
      button.classList.toggle('is-selected', isSelected);
    });

    const productCard = card.querySelector('[data-product-card]');

    if (productCard) {
      const productId = product.productId == null ? '' : String(product.productId);
      const variantId = product.variantId == null ? '' : String(product.variantId);

      if (productId) {
        productCard.dataset.productId = productId;
      } else {
        delete productCard.dataset.productId;
      }

      if (variantId) {
        productCard.dataset.initialVariantId = variantId;
      } else {
        delete productCard.dataset.initialVariantId;
      }
    }

    const productChanged = Boolean(previousKey && previousKey !== key);

    syncWishlistProduct(card, product, productChanged);

    if (productChanged && swymReady) {
      refreshWishlistStates(swymReady, card);
    }

  };

  const setGroupedProductState = (card, key) => {
    const syncId = card.dataset.adventSyncId;

    if (!syncId) {
      setProductState(card, key);
      return;
    }

    const landing = card.closest(LANDING_SELECTOR) || document;

    landing.querySelectorAll('[data-advent-product-card]').forEach((candidate) => {
      if (candidate.dataset.adventSyncId === syncId) {
        setProductState(candidate, key);
      }
    });
  };

  const initializeCard = (card) => {
    if (card.dataset.adventInitialized === 'true') return;

    card.dataset.adventInitialized = 'true';

    card.querySelectorAll('[data-advent-product-select]').forEach((button) => {
      button.addEventListener('click', () => {
        setGroupedProductState(card, button.dataset.adventProductSelect);
      });
    });

    card.querySelectorAll('[data-advent-wishlist-button]').forEach((button) => {
      button.addEventListener('click', handleWishlistClick);
    });

    setProductState(card, card.dataset.adventInitialProduct || 'base');
  };

  const initializeLanding = (landing) => {
    landing.querySelectorAll('[data-advent-product-card]').forEach(initializeCard);

    if (swymReady) {
      refreshWishlistStates(swymReady, landing);
    }
  };

  const initializeAll = (scope = document) => {
    if (scope.matches && scope.matches(LANDING_SELECTOR)) {
      initializeLanding(scope);
    }

    scope.querySelectorAll(LANDING_SELECTOR).forEach(initializeLanding);
  };

  document.addEventListener('DOMContentLoaded', () => initializeAll());
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
